import { differenceInCalendarDays } from 'date-fns';

export class DateHelperUtil {
  public static isQuoteOld(dateStr?: string): boolean {
    if (!dateStr || dateStr.length < 3) {
      return false;
    }
    return differenceInCalendarDays(Date.now(), Date.parse(dateStr)) > 0;
  }

  public static toIsoDateString(date: Date): string {
    return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
  }
}
